import { CommonFunctions } from '../static/common-functions';
import { BaseBus } from './BaseBus';
import { GItem } from './GItem';
import { AssignablePersonBus } from './AssignablePersonBus';

export class AzugaNearestVehicleBus extends BaseBus
{
  CID(): any {
      return this.trackeeId;
  }
    constructor(data: AzugaNearestVehicleBus) {
        super(data);
        if (data) {
            this.person = new AssignablePersonBus(data.person);
        }
    }
    trackeeId: any;
    trackeeName: string;
    llat: number;
    lng: number;
    address: string;
    googleDrivingDistance: number;
    googleDriveTime: number;
    googleDriveTimeDisplay: string;
    dateAndTime: number;
    offset: number;
    userId: string;
    firstName: string;
    lastName: string;
    eventName: string;
    deviceId: any;
    groupId: any;
    visits: number;
    person: AssignablePersonBus;
    dispatches: GItem[];
    get dispatchesCount(): number {
        return CommonFunctions.hasArrayElementValue(this.dispatches) ? this.dispatches.length : 0;
    }
}
